import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetJurisdictionLaborPostersRequestSchema,
  TGetJurisdictionLaborPostersResponseSchema,
} from "./getJurisdictionLaborPosters.schema";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";

export const getJurisdictionLaborPosters = (axios: IAxiosInstance) => {
  return async ({
    jurisdiction,
  }: TGetJurisdictionLaborPostersRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetJurisdictionLaborPostersResponseSchema>
    >(`/labor-posters/jurisdictions/${jurisdiction}`, {
      params: {
        limit: 9999, // TODO(jere): find a better way to paginate in custom paperwork
      },
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
